import React, { useState, useContext } from "react";
import { Field, Formik } from "formik";
import { Button, Form } from "react-bootstrap";
import {
  FieldInput,
  FieldInputNumber,
  SliderPanel,
  LoaderWrapper,
  ManageTempMapLayout,
} from "../../../components";
import {
  manageMapperStore,
  setMapperFilterData,
  setMapperFilterDataEdit,
  setManageMapperPageLevelData,
  MANAGE_MAPPER_POST_API_ERROR,
  setManageMapperToastInfo,
} from "../../../contexts";
import {
  FLOW_TYPES,
  manageMapperFormNames,
  MANAGE_PAYROLL_ROUTES,
  mapperFormFields,
  ROUTES,
} from "../../../utils";
import { isEmpty, get } from "lodash-es";
import { Link } from "react-router-dom";
import { useRouterParams } from "../../../abstracts";
import { onFixedLengthFileCreate } from "../../../services";
import FixedWidthSwitchComponent from "../../../components/FixedWidthSwitchComponent";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faExclamationCircle } from "@fortawesome/pro-light-svg-icons";

const FileSpecificationsContainer = (props) => {
  const { state, dispatch } = useContext(manageMapperStore);
  const { flow, profileId } = useRouterParams();
  const data = get(state, "api.data", []);

  const isEdit = flow === FLOW_TYPES.EDIT;
  const fileUpload = get(state, "api.fileuploadData.mappingConfiguration", {});
  const filename = get(fileUpload, "fileName", [])
    ? get(fileUpload, "fileName", [])
    : get(state, "api.data", []).fileName;
  const splitFilename = filename?.split(".");
  const extension = splitFilename[1];
  const configuration = get(fileUpload, "configurationJson")
    ? get(fileUpload, "configurationJson", {})
    : get(data, "configurationJson", {});
  const [sliderOpen, setSliderOpen] = useState(false);
  const fixedWidthData = get(data, "fixedLengthContainer.values", "");
  const fileUploadSectionsParse = JSON.parse(configuration).sections;
  const savedFixedWidthData = fileUploadSectionsParse
    ? fileUploadSectionsParse
    : get(data, "configurationJson", "") &&
      JSON.parse(get(data, "configurationJson", [])).sections;
  const [tempName, setTempName] = useState("");
  const [errors, setErrors] = useState([]);
  const buttons = [
    {
      label: "Cancel",
      variant: "secondary",
      type: "button",
      link: ROUTES.PAYROLL,
    },

    {
      label: "Next",
      variant: "primary",
      type: "submit",
    },
  ];

  const formName = manageMapperFormNames.FIXED_LENGTH;
  const fields = mapperFormFields[formName];
  const [errorMsg, setErrorMsg] = useState("");
  const [activeIndex, setActiveIndex] = useState(0);
  const [dataLoading, setDataLoading] = useState(false);

  const onSubmit = (values) => {
    setDataLoading(true);
    const { history } = props;
    let order = 0;
    let newValues = values.map((item) => ({
      ...item,
      fixedWidthFileSettings: item.fixedWidthFileSettings.map((x) => ({
        ...x,
        order: order++,
      })),
    }));
    let check = [];
    let errorMsgs = [];
    if (values.length > 1) {
      values.map((item, index) => {
        item.fixedWidthFileSettings.map((x) => {
          if (x.isKey === true) {
            check[index] = { ...check[index], isKey: true };
          }
          if (x.isSectionIndicator === true) {
            check[index] = { ...check[index], isSectionIndicator: true };
          }
        });
        if (!check[index]) {
          check[index] = [];
        }
        if (isEmpty(check[index])) {
          errorMsgs[index] = "Key Field and Indicator are required";
        } else if (!check[index].isKey) {
          errorMsgs[index] = "Key Field is required";
        } else if (!check[index].isSectionIndicator) {
          errorMsgs[index] = "Indicator is required";
        } else {
          errorMsgs.splice(index, 1);
        }
      });
    } else {
      check = values[activeIndex].fixedWidthFileSettings.find(
        (item) => item.isKey === true
      );
      if (isEmpty(check)) errorMsgs[activeIndex] = "Key Field is required";
    }
    setErrors(errorMsgs);
    if (isEmpty(errorMsgs)) {
      onFixedLengthFileCreate({
        ...data,
        profileId,
        configurationJson: JSON.stringify({
          ...JSON.parse(configuration),
          sections: newValues,
        }),
      })
        .then((res) => {
          if (!isEmpty(res)) {
            setDataLoading(false);
            if (!isEdit) {
              dispatch(setMapperFilterData(res));
            } else {
              dispatch(setMapperFilterDataEdit(res));
            }
            dispatch(
              setManageMapperPageLevelData({
                formName: "fixedLengthContainer",
                fieldData: { values: newValues },
              })
            );
            dispatch(
              setManageMapperToastInfo({
                showToast: true,
                toastMessage: "Data saved successfully",
              })
            );
            history.push(
              `${MANAGE_PAYROLL_ROUTES.MAP_AND_TRANSFORM}/${profileId}`
            );
          }
        })
        .catch((err) => {
          setDataLoading(false);
          dispatch({
            type: MANAGE_MAPPER_POST_API_ERROR,
            payload: "Something went wrong! please try again.",
          });
        });
    } else {
      setDataLoading(false);
    }
  };

  return (
    <Formik
      initialValues={
        savedFixedWidthData ? savedFixedWidthData : fixedWidthData || []
      }
      onSubmit={onSubmit}
      enableReinitialize
      validateOnChange={false}
      validateOnBlur={false}
    >
      {({ values, setValues, handleChange, setFieldValue, handleSubmit }) => {
        const addHeader = (name) => {
          if (name.length == 0) {
            setErrorMsg("Required");
          } else {
            setValues([
              ...values,
              {
                name: tempName,
                fixedWidthFileSettings: [
                  {
                    fieldName: "",
                    isKey: false,
                    isSectionIndicator: false,
                    indicator: "",
                    from: "",
                    to: "",
                    length: null,
                  },
                ],
              },
            ]);
            setErrorMsg("");
            setSliderOpen(false);

            setActiveIndex(values.length);
            setTempName("");
          }
        };
        const deleteHeader = (index) => {
          setValues(values.filter((item, ind) => ind != index));
          setActiveIndex(activeIndex === 0 ? activeIndex : activeIndex - 1);
          errors.splice(index, 1);
        };

        const addComponent = () => {
          setValues(
            values.map((item, index) => {
              if (index == activeIndex) {
                return {
                  ...item,
                  fixedWidthFileSettings: [
                    ...item.fixedWidthFileSettings,
                    {
                      fieldName: "",
                      isKey: false,
                      isSectionIndicator: false,
                      indicator: "",
                      from: "",
                      to: "",
                      length: null,
                    },
                  ],
                };
              } else return item;
            })
          );
        };

        const deleteComponent = (itemIndex) => {
          let newValues = values.map((item, index) => {
            if (index == activeIndex) {
              return {
                ...item,
                fixedWidthFileSettings: item.fixedWidthFileSettings.filter(
                  (x, i) => i != itemIndex
                ),
              };
            } else return item;
          });
          newValues = newValues.filter(
            (item, index) => item.fixedWidthFileSettings.length > 0
          );
          setValues(newValues);
          setActiveIndex(
            activeIndex >= newValues.length ? activeIndex - 1 : activeIndex
          );
        };
        const setKeyFieldCheck = (itemIndex, isKey) => {
          setValues(
            values.map((item, index) => {
              let keyValue = !values[activeIndex]["fixedWidthFileSettings"][
                itemIndex
              ][fields.isKey];
              let indicatorValue = !values[activeIndex][
                "fixedWidthFileSettings"
              ][itemIndex][fields.isSectionIndicator];
              if (index == activeIndex) {
                return {
                  ...item,
                  fixedWidthFileSettings: item.fixedWidthFileSettings.map(
                    (x, i) => {
                      if (i == itemIndex) {
                        return isKey
                          ? {
                              ...x,
                              [fields.isKey]: keyValue,
                              [fields.isSectionIndicator]: keyValue
                                ? !keyValue
                                : x[fields.isSectionIndicator],
                            }
                          : {
                              ...x,
                              [fields.isSectionIndicator]: indicatorValue,
                              [fields.isKey]: indicatorValue
                                ? !indicatorValue
                                : x[fields.isKey],
                            };
                      } else
                        return isKey
                          ? {
                              ...x,
                              [fields.isKey]: keyValue
                                ? !keyValue
                                : x[fields.isKey],
                            }
                          : {
                              ...x,
                              [fields.isSectionIndicator]: indicatorValue
                                ? !indicatorValue
                                : x[fields.isSectionIndicator],
                            };
                    }
                  ),
                };
              } else return item;
            })
          );
        };
        return (
          <Form onSubmit={handleSubmit}>
            <ManageTempMapLayout
              buttons={buttons}
              layoutHeader="File Specifications"
            >
              <LoaderWrapper isLoading={dataLoading}>
                {isEmpty(values) ? (
                  <div className="disp-flex-row marg-top-60">
                    <div className="bold-heading">Add A New Section</div>
                    <Link
                      className="click-me"
                      onClick={() => setSliderOpen(true)}
                    >
                      Click Here
                    </Link>
                  </div>
                ) : (
                  <div className="disp-flex-row w-100 marg-top-50">
                    <div className="left-section">
                      <div className="left-section-header">
                        <div className="section-header pad-bot-15">
                          Sections
                        </div>
                        <i
                          className="fas fa-plus-circle"
                          style={{
                            color: "#307BF6",
                            fontSize: "18px",
                            fontWeight: "900",
                            cursor: "pointer",
                            paddingTop: "5px",
                          }}
                          onClick={() => setSliderOpen(true)}
                        ></i>
                      </div>
                      <div className="disp-flex-col marg-top-15">
                        {values.map((data, index) => (
                          <div className="d-flex">
                            <div
                              key={index}
                              className="headers disp-flex-row"
                              onClick={() => {
                                setActiveIndex(index);
                              }}
                            >
                              <div
                                className={
                                  index === activeIndex
                                    ? "active-header"
                                    : "inactive-header"
                                }
                              ></div>
                              <div
                                className={`${
                                  index === activeIndex
                                    ? "active-headerName"
                                    : "inactive-headerName"
                                }`}
                                style={{ paddingLeft: "15px", width: "200px" }}
                                onClick={() => setActiveIndex(index)}
                              >
                                {data.name}
                              </div>
                            </div>
                            {!isEmpty(errors[index]) && (
                              <FontAwesomeIcon
                                icon={faExclamationCircle}
                                size="1x"
                                style={{
                                  color: "#ff5050",
                                  marginTop: "0.25rem",
                                }}
                              />
                            )}
                          </div>
                        ))}
                      </div>
                    </div>

                    <div className="right-section">
                      <div className="right-section-header">
                        <div className=" d-flex">
                          <div className="section-header pad-bot-15">
                            {values[activeIndex]["name"]}
                          </div>
                          <div
                            style={{
                              fontSize: "1rem",
                              marginLeft: "10%",
                              color: "#ff5050",
                              minWidth: "max-content",
                            }}
                          >
                            {errors[activeIndex]}
                          </div>
                        </div>

                        <i
                          class="fas fa-trash"
                          style={{
                            color: "#EB4E3D",
                            fontSize: "18px",
                            fontWeight: "900",
                            cursor: "pointer",
                            lineHeight: "21px",
                            paddingRight: "15px",
                          }}
                          onClick={() => deleteHeader(activeIndex)}
                        ></i>
                      </div>

                      <div className="component-list-container disp-flex-row">
                        <div className="disp-flex-col">
                          {values[activeIndex]["fixedWidthFileSettings"].map(
                            (data, index) => (
                              <div>
                                <div
                                  className={`disp-flex-row align-center w-100 marg-top-15 `}
                                >
                                  <div className="index">{index + 1}</div>

                                  <Field
                                    size="md"
                                    isRequired
                                    className="w-200 marg-right-20"
                                    name={`[${activeIndex}][fixedWidthFileSettings][${index}][${fields.fieldName}]`}
                                    label={"Field Name"}
                                    type="text"
                                    autoComplete="off"
                                    value={data[fields.fieldName]}
                                    onChange={handleChange}
                                    component={FieldInput}
                                  />

                                  <Field
                                    size="sm"
                                    isRequired
                                    className="w-80 marg-right-20 "
                                    name={`[${activeIndex}][fixedWidthFileSettings][${index}][${fields.from}]`}
                                    placeHolder="From"
                                    label="From"
                                    type="text"
                                    autoComplete="off"
                                    value={data[fields.from]}
                                    onChange={handleChange}
                                    component={FieldInputNumber}
                                  />

                                  <Field
                                    size="sm"
                                    isRequired
                                    className="w-80 marg-right-20"
                                    name={`[${activeIndex}][fixedWidthFileSettings][${index}][${fields.to}]`}
                                    placeHolder="To"
                                    label="To"
                                    type="text"
                                    autoComplete="off"
                                    value={data[fields.to]}
                                    onChange={handleChange}
                                    component={FieldInputNumber}
                                  />

                                  <Field
                                    size="sm"
                                    isRequired
                                    className="w-80 marg-right-20"
                                    name={`[${activeIndex}][fixedWidthFileSettings][${index}][${fields.length}]`}
                                    label="Length"
                                    placeHolder="Length"
                                    type="text"
                                    autoComplete="off"
                                    value={
                                      data[fields.to] - data[fields.from] + 1
                                    }
                                    onChange={handleChange}
                                    disabled={true}
                                    component={FieldInput}
                                  />
                                  <FixedWidthSwitchComponent
                                    checked={data[fields.isKey]}
                                    setChecked={() =>
                                      setKeyFieldCheck(index, true)
                                    }
                                    label={"Key Field"}
                                  />
                                  <FixedWidthSwitchComponent
                                    checked={data[fields.isSectionIndicator]}
                                    setChecked={() =>
                                      setKeyFieldCheck(index, false)
                                    }
                                    label={"Indicator"}
                                  />
                                  {data.isSectionIndicator && (
                                    <Field
                                      size="sm"
                                      isRequired
                                      className="w-80 marg-right-20"
                                      name={`[${activeIndex}][fixedWidthFileSettings][${index}][${fields.value}]`}
                                      label="Value"
                                      placeHolder="Value"
                                      type="text"
                                      autoComplete="off"
                                      value={data[fields.value]}
                                      onChange={handleChange}
                                      component={FieldInput}
                                    />
                                  )}
                                  <i
                                    className="fas fa-trash"
                                    style={{
                                      color: "#EB4E3D",
                                      fontSize: "18px",
                                      fontWeight: "900",
                                      cursor: "pointer",
                                      lineHeight: "21px",
                                      marginRight: "20px",
                                      paddingTop: "22px",
                                    }}
                                    onClick={() => deleteComponent(index)}
                                  ></i>
                                  <i
                                    className="fas fa-plus-circle "
                                    style={{
                                      color: "#307BF6",
                                      fontSize: "18px",
                                      fontWeight: "900",
                                      cursor: "pointer",
                                      paddingTop: "22px",
                                    }}
                                    onClick={() => addComponent()}
                                  ></i>
                                </div>
                              </div>
                            )
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                )}

                <SliderPanel
                  isOpen={sliderOpen}
                  size="35"
                  showCancel={false}
                  backdropClicked={() => setSliderOpen(false)}
                >
                  {" "}
                  <div className="disp-flex-row w-100 flex-end">
                    <Button
                      className="w-100px marg-right-10"
                      onClick={() => {
                        addHeader(tempName);
                      }}
                    >
                      Save
                    </Button>
                    <Button
                      className=""
                      variant="secondary"
                      onClick={() => setSliderOpen(false)}
                    >
                      Cancel
                    </Button>
                  </div>
                  <div className=" disp-flex-col justify-content-space-between h-150">
                    <Field
                      name={"cloneProfileName"}
                      label={"Enter Section Name"}
                      component={FieldInput}
                      onChange={(e) => setTempName(e.target.value)}
                      noLabelTransform
                      isRequired
                    />
                    <div
                      style={{
                        fontSize: "0.75rem",
                        marginTop: "-0.75rem",
                        paddingTop: "0rem",
                        color: "#ff5050",
                      }}
                    >
                      {errorMsg}
                    </div>
                  </div>
                </SliderPanel>
              </LoaderWrapper>
            </ManageTempMapLayout>
          </Form>
        );
      }}
    </Formik>
  );
};

export default FileSpecificationsContainer;
